import React, { Component } from "react";
import {
    withRouter
} from "react-router-dom";
import {
    Page,
    Text,
    Card,
    Button,
    ProgressBar,
    BlockStack,
    Tooltip,
    Banner,
    Badge,
    Icon,
    Modal,
    Spinner,
    Collapsible,
    Tabs,
    RadioButton,

} from "@shopify/polaris";
import {
    ChevronDownMinor,
    ChevronUpMinor,
    CircleAlertMajor,
    QuestionMarkMinor,
    MobileHorizontalDotsMajor,
    ViewMinor,

} from "@shopify/polaris-icons";

import { store } from "../../../redux/store";
import "./index.scss";
import Switch from "react-switch";
import SpeedBasicIcon from '../../../assets/SpeedUp/SpeedBasicIcon.jsx';
import SpeedFastIcon from '../../../assets/SpeedUp/SpeedFastIcon.jsx';
import SpeedRocketIcon from '../../../assets/SpeedUp/SpeedRocketIcon.jsx';
import SuInstantPageIcon from '../../../assets/SpeedUp/SuInstantPageIcon.jsx';
import SuStreamlinedLoading from '../../../assets/SpeedUp/SuStreamlinedLoading.jsx';
import SuLazyLoading from '../../../assets/SpeedUp/SuLazyLoading.jsx';
import SuOptimizedLoading from '../../../assets/SpeedUp/SuOptimizedLoading.jsx';
import SuAssetsFileOptimization from '../../../assets/SpeedUp/SuAssetsFileOptimization.jsx';
import SuStreamlineCode from '../../../assets/SpeedUp/SuStreamlineCode.jsx';
import LightningIcon from '../../../assets/SpeedUp/LightningIcon.jsx';
import SettingsIcon from '../../../assets/SpeedUp/SettingsIcon.jsx';
// 翻译
import Language from "../../../i18n/Language";
import utils from "../../../utils/utils";
import FaqCardBox from "../../../components/FaqCardBox";
import { cloneDeep } from "lodash";
import {
    reqCopyThemeData,
    reqSpeedUpData,
    reqSpeedUpSetting,
    reqGetSpeedupRecord,
    reqUpSpeedUpSetting,
    reqStartSpeedUp,
    reqActionThemeData,
    reqRestartSpeedUp,
    reqCheckWebStatus,
    reqCloseSucPubBanner,

} from "../../../api";
import { connect } from "react-redux";
import UpgradeModal from "../../../components/UpgradeModal";
import ViewImage from "../../../components/ViewImage/index.jsx";
import SkeltonLoading from "../../../components/SkeltonLoading/index.jsx";
import { setSaveSwitchData } from "../../../redux/actions/getAppPublicData.js";
import { setPageData } from "../../../redux/actions/getAppPageData.js";
import FooterTrustHelp from "../../../components/FooterTrustHelp/index.jsx";
const t = Language;
let themeArr = [], recordArr = [];
class SiteSpeedup extends Component {
    state = {
        showToast: false,
        showToastText: '',
        showToastIserror: '',
        loadingPage: true,
        planId: 1,                                          // 加速版本id
        isShowProgress: false,                              // 进度列表状态
        questionList: {
            high_score: {
                title: "What are the benefits of having a high Google Pagespeed score for a store?",
                tag: [
                    "Improved user experience: Faster load times can lead to a better user experience, making it easier for visitors to navigate and engage with your website.",
                    "Higher search engine rankings: Google considers page speed as a ranking factor in its search algorithm, so optimizing your website for faster load times can help improve its visibility in search results.",
                    "Competitive advantage: A faster website can give you a competitive advantage over other websites in your industry, as users are more likely to engage with a site that loads quickly and efficiently."
                ]
            },
            increase_in: {
                title: "What is the potential increase in score if I enable the Speed Up?",
                tag: ["It is difficult to determine the exact potential increase in score that can be achieved by enabling the Speed Up feature as it can vary depending on the website's current performance and optimization. However, enabling this feature can generally lead to improved loading times and overall performance."]
            },
            speed_theme: {
                title: "Will the speed optimization function change my theme code?",
                tag: [
                    "Some speed-up functions will insert code into your website and affect the theme, but don't worry, we provide a copy theme function, you can apply the function test on the copy theme"
                ]
            },
            use_feature: {
                title: "How do I use this feature?",
                tag: [
                    "We optimize your website speed through Preload Pages, Streamlined Loading, Asset File Optimization and other features. We recommend that you perform another website speed optimization after the initial website speed optimization and when your website content is updated."
                ]
            }
        }, // 问题列表
        serversList: [
            {
                id: 1,
                status: false,
                mStatus: false,
                plan: 1,
                name: "Instant Page",
                title: "instant_page",
                func: [1, 1, 1],
                desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload.",
                copys: false,
                svg: SuInstantPageIcon,
            },
            {
                id: 3,
                status: false,
                mStatus: false,
                plan: 2,
                name: "Lazy Load Images",
                title: "lazy_loading",
                func: [0, 1, 1],
                desc: "Delay loading images until they appear on screen to improve speed and reduce data usage.",
                copys: false,
                svg: SuLazyLoading,
            },
            {
                id: 8,
                status: false,
                mStatus: false,
                plan: 3,
                name: "Lazy Load Videos & Iframes",
                title: "video_lazy",
                func: [0, 0, 1],
                desc: "Delay the loading of embedded videos and iframes until they are visible on screen.",
                copys: true,
                svg: SuLazyLoading,
            },
            {
                id: 2,
                status: false,
                mStatus: false,
                plan: 2,
                name: "Streamlined Loading",
                title: "streamline_loading",
                func: [0, 1, 1],
                desc: "When users visit the website, limit the loading of third-party resources and the execution of unnecessary programs. Prioritize loading your own website resources to save the time spent on loading third-party resources.",
                copys: true,
                svg: SuStreamlinedLoading,
            },
            {
                id: 5,
                status: false,
                mStatus: false,
                plan: 3,
                name: "Optimized Loading",
                title: "optimize_loading",
                func: [0, 0, 1],
                desc: "Identify and prioritize loading critical CSS to improve website speed.",
                copys: true,
                svg: SuOptimizedLoading,
            },
            {
                id: 6,
                status: false,
                mStatus: false,
                plan: 3,
                name: "Asset File Optimization",
                title: "asset_file_optimize",
                func: [0, 0, 1],
                desc: "Optimize all assets to reduce loading time and enhance theme performance.",
                copys: true,
                svg: SuAssetsFileOptimization,
            },
            {
                id: 7,
                status: false,
                mStatus: false,
                plan: 3,
                name: "Streamline Code",
                title: "streamline_code",
                func: [0, 0, 1],
                desc: "Remove unnecessary information from the <Assets> code, such as spaces, line breaks, and comments, to help your pages load faster.",
                copys: true,
                svg: SuStreamlineCode,
            },
            // {
            //     id: 4,
            //     status: false,
            //     mStatus: false,
            //     plan: 2,
            //     name: "Stable Loading",
            //     title: "stable_loading",
            //     func: [0, 1, 1],
            //     desc: "Hides the page's main content until it loads. Improves the Cumulative Layout Shift metric by stabilizing the page.",
            //     svg: SuStableLoading,
            // },
        ],
        isShowConfirmModal: false,                          // 加速确认状态
        isShowSettingPage: false,                           // 设置页面
        isShowPublicTip: false,                             // 发布主题提示弹窗
        level: 1,
        domain: "",                                         // 用户域名
        taskCpl: 0,                                         // 完成任务数量
        taskAll: 1,                                         // 全部任务数量
        isShowCompleteBanner: false,                        // 是否显示优化完成banner
        isShowChooseTheme: false,                           // 选择主题弹窗
        isShowSuccessBanner: false,                         // 发布成功提示
        tabKey: 0,
        upgradeBtn: false,
        speedupCopyState: true,                               // 加速复制主题按钮状态
        speedupCopyLoading: false,                            // 加速复制主题按钮loading
        speedupThemeName: "",                                 // 加速主题名称
        copyThemeId: -1,                                      // 复制主题id
        themeList: [],                                        // 主题记录列表
        themeListLoading: true,                               // 主题记录列表loading
        selectThemeId: -1,                                    // 优化主题id
        isSwitch: -1,
        modalToPlan: false,                                   // 弹窗到版本
        upgradeModalShow: this.props.upgradeModalShow,
        imgUrl: '',
        recordList: [
            {
                id: 10,
                title: "read_all_files",
                SupStatus: 0,                                   // 0不优化 1优化完成 2优化中 3待优化
                do: "Read theme files",
                plan: 2,
                nums: {
                    current: 0,
                    all: 0,
                }
            },
            {
                id: 11,
                title: "instant_page",
                SupStatus: 0,
                do: "Add instant page",
                plan: 1,
            },
            {
                id: 12,
                title: "streamline_loading",
                SupStatus: 0,
                do: "Optimize Resource Loading Content",
                plan: 2,
            },
            {
                id: 13,
                title: "lazy_loading",
                SupStatus: 0,
                do: "Enable Lazy-loading",
                plan: 2,
            },
            {
                id: 14,
                title: "streamline_code",
                SupStatus: 0,
                do: "Streamline Code",
                plan: 3,
            },
            {
                id: 15,
                title: "asset_file_optimize",
                SupStatus: 0,
                do: "Optimize Asset Files",
                plan: 3,
            },
            {
                id: 16,
                title: "optimize_loading",
                SupStatus: 0,
                do: "Identify Critical CSS",
                plan: 3,
            },
            {
                id: 17,
                title: "video_lazy",
                SupStatus: 0,
                do: "Lazy Load Videos & Iframes",
                plan: 3,
            },
        ],
        LastOptTime: '-',                                      // 上次优化时间
        isAllBtnFalse: false,                                  // 全部禁止
        publicBtnLoading: false,                               // 发布loading
        bannerSite: 'top',                                     // top || modal
        isShowErrorTip: false,
        isSetState: true,
        operaThemeId: -1,                                      // 操作的主题id
        operaThemeName: '',                                    // 操作的主题名称
        excessPlan: 1,                                         // 选中套餐需要的等级
        isOnlySpeedLoading: false,                             // 是否直接加速loading
        isShowSpedTip: true,                                   // 删除提示banner
        bf_theme: {},
        restoreListLoading: true,
        restoreThemeList: [],                                  // 恢复主题列表
        themeAppExtensionUrl: '',                              // 扩展链接
        startRestoreLoading: false,                            // 恢复按钮loading
        currentThemeId: -1,                                    // 当前主题id
        isTimeOut: false,                                      // 是否超时
        reoptLoading: false,                                   // 重新优化
        isPwd: !false,                                         // 是否需要密码
        recordId: -1,                                          // 恢复id

        isShowSecTip: false,                                    // 新手引导状态
        isShowPop: false,
        isGuideTip: false,
        reduxLoading: true,
        uName: "",                                              // 用户名称
        isForbitSpeedup: false,                                // 是否禁止加速 300秒内不能加速
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.upgradeModalShow !== this.props.upgradeModalShow) {
            // 判断是否二次弹窗
            if (!nextProps.upgradeModalShow && this.state.modalToPlan) {
                this.setState({
                    isShowConfirmModal: true,
                    modalToPlan: false,
                })
            }
        }

        return true;
    }

    componentDidMount() {
        const _params = this.props.location;
        let _store = store.getState().public;
        let _page = store.getState().page;
        let isShowSecTip = false;
        try {
            isShowSecTip = !Boolean(sessionStorage.getItem('speedupSecTip'));
        } catch (e) { }
        this.setState({
            level: _store.level,
            planId: _store.level,
            domain: _store.domain,
            uName: _store.publicInit?.shop_data.name,
            themeAppExtensionUrl: _store.publicInit?.other_options.seoant_core_url || '',

            isGuideTip: Boolean(_params?.query === "showPopover"),
            isShowSecTip,
        }, () => {
            this.checkWebsiteState();
            this.getSpeedupSetting(false, _page.pageInit.SiteSpeedUp);
        })
    }

    // 检测状态
    checkWebsiteState = async () => {
        const res = await reqCheckWebStatus();
        if (res.ack === 1) {
            this.setState({
                isPwd: res.data.status === 2 || res.data.is_password === 1,
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取加速设置
    getSpeedupSetting = async (isGetTheme = false, _reduxData = null, isGetRecord = true) => {
        let res = {};
        if (_reduxData?.SpeedUpSettings) {
            res = _reduxData.SpeedUpSettings;
        } else {
            res = await reqSpeedUpSetting();
        }
        if (res.ack === 1) {
            if (_reduxData?.SpeedUpSettings) {
                this.getSpeedupSetting(false, null);
            }
            this.props.getPageDataRedux({ 'SpeedUpSettings': res });
            let { serversList } = this.state;
            let newList = cloneDeep(serversList);
            newList.forEach((item) => {
                item.status = Boolean(res.data.switch[item.title]);
            })
            this.setState({
                serversList: newList,
                bf_theme: res.data.before_theme,
                LastOptTime: res.data.last_opt_at || 0,
                currentThemeId: res.data.theme.theme_id,
            }, () => {
                if (isGetRecord) {
                    this.getSpeedupRecord(_reduxData, true);
                }
                if (isGetTheme) {
                    this.getSeoantThemeData();
                }
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }

        return true;
    }

    // 获取优化记录
    getSpeedupRecord = async (_reduxData = null, isGetRecord = true) => {
        let res = {};
        if (_reduxData?.SpeedUpRecord) {
            res = _reduxData?.SpeedUpRecord;
        } else {
            res = await reqGetSpeedupRecord();
        }
        if (res.ack === 1) {
            this.props.getPageDataRedux({ 'SpeedUpRecord': res });
            let _t = res.data;
            let isMoreThan = _t?.updated_at ? (((new Date().getTime()) / 1000 - _t.updated_at) > (30 * 60)) : false;
            let { recordList, isShowProgress, currentThemeId } = this.state;
            let optFun = _t?.opt_fun ? JSON.parse(_t.opt_fun) : {};
            // 获取设置状态
            let newList = cloneDeep(recordList);
            newList.forEach(item => {
                item.SupStatus = optFun[item.title] || 0;
                if (Boolean(_t.read_status) && item.title === "read_all_files") {
                    item.SupStatus = _t.read_status;
                    item.nums = {
                        current: _t.current_asset_num || 0,
                        all: _t.asset_num || 0,
                    }
                }
            })
            let hasState = newList.filter(i => i.SupStatus !== 0);
            let finishState = newList.filter(i => i.SupStatus === 1);
            this.setState({
                loadingPage: false,
                recordList: newList,
                isShowProgress: hasState.length === 0 ? isShowProgress : true,
                isAllBtnFalse: finishState.length === hasState.length ? false : true,
                taskCpl: finishState.length,
                taskAll: hasState.length,
                operaThemeId: _t.theme_id,
                operaThemeName: _t.theme_name,
                isTimeOut: isMoreThan && finishState.length !== hasState.length,
                recordId: _t.id,
                reduxLoading: Boolean(_reduxData?.SpeedUpRecord),
            }, () => {
                // 判断是否全部执行完成
                if (Object.keys(_t).length > 0) {
                    if (finishState.length === hasState.length) {
                        this.setState({
                            isShowCompleteBanner: Boolean(_t.is_publish === 0) && currentThemeId !== _t.theme_id,
                            isShowSuccessBanner: Boolean(_t.is_publish === 1) && currentThemeId === Number(_t.theme_id) && !Boolean(_t?.is_close_banner),
                        }, () => {
                            if(!isGetRecord) {
                                this.getSpeedupSetting(false, null, false);
                            }
                            this.clearRecordGet(true);
                        })
                    } else {
                        // 继续轮询优化
                        if (recordArr.length === 0) {
                            let timer = setInterval(() => {
                                this.getSpeedupRecord();
                            }, 3000)
                            recordArr.push(timer);
                        }
                    }
                }

                // 动画过渡
                setTimeout(() => {
                    this.setState({ isShowPop: true })
                }, 200)
            })
        } else {
            this.setState({
                bannerSite: 'top',
            }, () => {
                this.setErrorBanner(res.msg);
            })
        }
    }

    // 获取复制主题信息
    getCopyThemeData = async () => {
        const res = await reqCopyThemeData();
        if (res.ack === 1) {
            if (res.data?.previewable) {
                this.clearThemeGet(); // 清除
                this.setState({
                    speedupCopyState: false,
                    speedupCopyLoading: false,
                    copyThemeId: res.data.id,
                    speedupThemeName: res.data.name,
                })
            } else {
                if (Object.keys(res.data).length > 0) {
                    this.setState({
                        speedupCopyLoading: true,
                    })
                }
                if (themeArr.length === 0) {
                    let timer = setInterval(() => {
                        this.getCopyThemeData();
                    }, 6000)
                    themeArr.push(timer);
                }
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取主题记录
    getSeoantThemeData = async () => {
        const res = await reqSpeedUpData();
        if (res.ack === 1) {
            this.setState({
                themeList: res.data,
                restoreThemeList: [this.state.bf_theme, ...res.data],
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }

        this.setState({
            themeListLoading: false,
            restoreListLoading: false,
        })
    }

    // 选择优化主题
    handleSelectTheme = (id, isDel) => {
        if (isDel === 0) {
            this.setState({
                selectThemeId: id,
            })
        }
    }

    // 服务开关
    handleChangeSwitch = (data) => {
        let { level, serversList } = this.state;
        if (!data.status && ((data.plan > 1 && level === 1) || (data.plan > 2 && level <= 2))) {
            let e = data.plan === 2 ? 1 : 2;
            this.props.show(e);
        } else {
            let newList = cloneDeep(serversList);
            newList.forEach(item => {
                if (item.id === data.id) {
                    item.status = !Boolean(item.status);
                }
            })
            this.setState({
                serversList: newList,
                isSwitch: data.id,
            }, () => {
                this.updateSwitchData(newList, 'setting');
            })
        }
    }

    // 弹窗服务开关
    handleChangeModalSwitch = (data) => {
        let { level, serversList } = this.state;
        if (!data.mStatus && ((data.plan > 1 && level === 1) || (data.plan > 2 && level <= 2))) {
            let e = data.plan === 2 ? 1 : 2;
            this.props.show(e);
            this.setState({
                isShowConfirmModal: false,
                modalToPlan: true,
            })
        } else {
            let newList = cloneDeep(serversList);
            newList.forEach(item => {
                if (item.id === data.id) {
                    item.mStatus = !Boolean(item.mStatus);
                }
            })
            this.setState({
                excessPlan: this.getSetNeedPlan(newList),
                serversList: newList,
            })
        }
    }

    // 更新开关数据
    updateSwitchData = async (all, type = 'setting') => {
        let objs = {
            switch: {}
        }
        all.forEach(item => {
            if (type === 'setting') {
                objs.switch[item.title] = Number(Boolean(item.status));
            } else {
                objs.switch[item.title] = Number(Boolean(item.mStatus));
            }
        })
        const res = await reqUpSpeedUpSetting(objs);
        if (res.ack === 1) {
            this.props.toggleToast(res.msg);
            // 更新新手引导状态
            let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
            if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
                data.manual_guide.speed_up = { "at": Math.floor(new Date().getTime() / 1000), "st": 1 };
                store.dispatch(setSaveSwitchData(data));
            }
            if (type === 'modal') {
                this.setState({
                    isShowConfirmModal: false,
                    isOnlySpeedLoading: false,
                }, () => {
                    this.getSpeedupSetting();
                })
            }
        } else {
            this.setState({
                bannerSite: 'modal',
                isOnlySpeedLoading: false,
            }, () => {
                this.setErrorBanner(res.msg);
            })
        }
        if (res) {
            this.setState({
                isSwitch: -1
            })
        }
    }

    // 选择加速版本
    handleSelectPlan = (e) => {
        this.setState({
            planId: e
        })
    }

    // 展开隐藏
    toggleProgressList = () => {
        let { isShowProgress } = this.state;
        this.setState({
            isShowProgress: !isShowProgress,
        })
    }

    // 版本比较弹窗
    toggleCompareModal = () => {
        let { level } = this.state;
        this.setState({
            upgradeBtn: level === 1 ? 'pro' : level === 2 ? 'pre' : 'all',
        })
    }

    // 加速确认弹窗
    toggleComfirmModal = (states) => {
        // 判断哪些服务开启
        let _state = Boolean(states);
        let { level, planId, serversList, themeList, isPwd, isGuideTip } = this.state;
        let newList = cloneDeep(serversList);
        if (_state) {
            if (themeList.length === 0) {
                this.getSeoantThemeData();
            }
            newList.forEach(i => {
                if ((planId === 1 && i.plan === 1) || (planId === 2 && i.plan <= 2) || (planId === 3)) {
                    if (level === 3 && i.title === "optimize_loading" && isPwd) {
                        i.mStatus = false;
                    } else {
                        i.mStatus = true;
                    }
                } else {
                    i.mStatus = false;
                    // if (i.status) {
                    //     i.mStatus = true;
                    // } else {
                    //     i.mStatus = false;
                    // }
                }
            })
        }
        let { LastOptTime } = this.state;
        let now = Math.floor(new Date().getTime() / 1000);
        this.setState({
            isForbitSpeedup: (now - LastOptTime) < 1800,
            excessPlan: this.getSetNeedPlan(newList),
            serversList: newList,
            isShowConfirmModal: Boolean(_state),
            isShowSecTip: false,
        }, () => {
            this.clearErrorBanner();
            if (isGuideTip) {
                try {
                    sessionStorage.setItem("speedupSecTip", "close");
                } catch (e) { }
            }
        })
    }

    // 获取当前需要的版本
    getSetNeedPlan = (data) => {
        let datas = data.filter(i => i.mStatus);
        let excessPlanArr = datas.map(i => {
            return i.plan;
        })
        return excessPlanArr.length === 0 ? 1 : Math.max(...excessPlanArr);
    }

    // 打开设置
    openSettingPage = () => {
        this.setState({
            isShowSettingPage: true,
        })
    }

    // 切换版本id
    changePlanId = (id, e) => {
        let { isAllBtnFalse } = this.state;
        if (!isAllBtnFalse) {
            let endId = id;
            if (e?.nativeEvent) {
                let width = e?.target.offsetWidth || 0;
                let clickRange = e.nativeEvent.offsetX;
                endId = (clickRange <= (width / 4)) ? 1 : (clickRange > (width / 4) && clickRange <= ((width / 4) * 3)) ? 2 : 3;
            }
            this.setState({
                planId: endId,
            })
        }
    }

    // 打开发布提示
    togglePublicTipState = () => {
        let { publicBtnLoading, isShowPublicTip } = this.state;
        if (!publicBtnLoading) {
            this.setState({
                isShowPublicTip: !isShowPublicTip,
            }, () => {
                this.clearErrorBanner();
            })
        }
    }

    // 设置完成提示banner
    setCompleteBanner = (states = false) => {
        this.setState({
            isShowCompleteBanner: Boolean(states)
        })
    }


    // 设置发布成功提示banner
    setSuccessBanner = (states = false) => {
        this.setState({
            isShowSuccessBanner: Boolean(states)
        }, async () => {
            const params = { record_id: this.state.recordId };
            await reqCloseSucPubBanner(params);
        })
    }

    // 开始发布主题
    publishThemeData = (type = 1) => {
        if (type === 1) {
            this.setState({
                publicBtnLoading: true,
            }, () => {
                this.startPublishTheme("publish")
            })
        } else {
            this.setState({
                isShowRestoreListModal: true,
                restoreListLoading: true,
            }, () => {
                this.getSeoantThemeData();
            })
        }
    }

    // 发布主题发起  publish|restore
    startPublishTheme = async (action) => {
        let params = {
            action
        }
        const res = await reqActionThemeData(params);
        if (res.ack === 1) {
            this.props.toggleToast(res.msg);
            this.setState({
                isShowPublicTip: false,
                isShowCompleteBanner: false,
                publicBtnLoading: false,
                isShowSuccessBanner: true
            }, () => {
                this.getSpeedupSetting(true);
            })
        } else {
            this.setState({
                publicBtnLoading: false,
                bannerSite: 'modal'
            }, () => {
                this.setErrorBanner(res.msg);
            })
        }
    }

    // 开始加速
    speedUpNow = () => {
        let { themeList, serversList } = this.state;
        let onlyObj = ["instant_page", "lazy_loading"];
        let openObj = [];
        serversList.forEach(item => {
            if (item.mStatus) {
                openObj.push(item.title);
            }
        })
        // 是否不用备份
        let needCopy = false;
        openObj.forEach(item => {
            if (!onlyObj.includes(item)) {
                needCopy = true;
            }
        })
        if (needCopy) {
            this.setState({
                isShowConfirmModal: false,
                isShowChooseTheme: true,
                tabKey: themeList.length > 0 ? 1 : 0,
            }, () => {
                if (themeList.length > 0) {
                    this.getSeoantThemeData();
                }
            })
        } else {
            // 直接发起优化
            this.setState({
                selectThemeId: this.state.operaThemeId,
                isOnlySpeedLoading: true,
            }, () => {
                this.updateSwitchData(serversList, 'modal');
            })
        }
    }

    // 切换tabs
    handleSelectTabs = (e) => {
        this.setState({
            tabKey: e
        }, () => {
            if (e === 1) {
                let { themeList } = this.state;
                if (themeList.length === 0) {
                    this.setState({
                        themeListLoading: true
                    })
                }
                this.getSeoantThemeData();
            }
        })
    }

    // 返回服务列表
    goBackServerList = () => {
        this.clearThemeGet();
        this.clearErrorBanner();
        this.setState({
            isShowConfirmModal: true,
            isShowChooseTheme: false,
            speedupCopyState: true,
            speedupCopyLoading: false,
            speedupThemeName: "",
            copyThemeId: -1,
            selectThemeId: -1,
            tabKey: 0,
        })
    }

    // 跳转主题
    GotoTheme = () => {
        let { uName } = this.state;
        window.open(`https://${uName}/admin/themes`);
        setTimeout(() => {
            this.getCopyThemeData();
        }, 1000)
    }

    // 开始优化复制主题
    SpeedupCopyTheme = (type = '') => {
        let { copyThemeId, selectThemeId, serversList } = this.state;
        // 判断主题是否有效
        if (((type === 'copy' && (!copyThemeId || copyThemeId === -1)) || (type === 'opt' && (!selectThemeId || selectThemeId === -1)))) {
            this.props.toggleToast(t("The theme id is invalid"), true);
        } else {
            this.setState({
                btnCopySupLoading: true,
            }, async () => {
                let switchData = {};
                serversList.forEach(item => {
                    switchData[item.title] = Number(Boolean(item.mStatus));
                })
                let params = {
                    theme_id: type === 'copy' ? copyThemeId : selectThemeId,
                    switch: switchData,
                }
                const res = await reqStartSpeedUp(params);
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg);
                    this.setState({
                        isShowSuccessBanner: false,
                        isShowCompleteBanner: false,
                        isShowPublicTip: false,
                        btnCopySupLoading: false,
                        isShowChooseTheme: false,
                        isAllBtnFalse: true,
                        selectThemeId: -1,
                        tabKey: 0,
                        speedupThemeName: '',
                    }, () => {
                        this.getSpeedupSetting();
                        if (recordArr.length === 0) {
                            this.getSpeedupRecord();
                            let timer = setInterval(() => {
                                this.getSpeedupRecord();
                            }, 3000)
                            recordArr.push(timer);
                        }

                        // 更新新手引导状态
                        let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
                        if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
                            data.manual_guide.speed_up = { "at": Math.floor(new Date().getTime() / 1000), "st": 1 };
                            store.dispatch(setSaveSwitchData(data));
                        }
                    })
                } else {
                    this.setState({
                        btnCopySupLoading: false,
                        isAllBtnFalse: false,
                        bannerSite: 'modal'
                    }, () => {
                        this.setErrorBanner(res.msg);
                    })
                }
            })
        }
    }

    // 开始恢复主题
    startRestoreTheme = () => {
        this.setState({
            startRestoreLoading: true,
        }, async () => {
            let { selectThemeId } = this.state;
            let params = {
                action: "restore",
                theme_id: selectThemeId
            }
            const res = await reqActionThemeData(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg);
                this.setState({
                    isShowRestoreListModal: false,
                    selectThemeId: -1,
                }, () => {
                    this.getSpeedupSetting();
                })
            } else {
                this.setState({
                    bannerSite: 'modal'
                }, () => {
                    this.setErrorBanner(res.msg);
                })
            }

            if (res) {
                this.setState({
                    startRestoreLoading: false,
                })
            }
        })
    }

    // 预览
    openViewImage = (url) => {
        this.setState({
            imgUrl: url
        })
    }

    // 关闭弹窗
    changeUpgradeState = () => {
        this.setState({
            upgradeBtn: false
        })
    }

    // 清除定时器
    clearThemeGet = () => {
        themeArr.map(timer => {
            clearInterval(timer);
            themeArr.pop();
            return false;
        })
    }

    // 清除记录定时器
    clearRecordGet = () => {
        recordArr.map(timer => {
            clearInterval(timer);
            recordArr.pop();
            return false;
        })
    }

    // 清空错误banner定义
    clearErrorBanner = () => {
        this.setState({
            bannerSite: '',
            isShowErrorTip: '',
            isSetState: true
        })
    }

    // 设置错误banner
    setErrorBanner = (res, cState = true) => {
        window.scrollTo(0, 0);
        this.setState({
            isShowErrorTip: res,
            isSetState: cState
        })
    }

    // 返回
    goBack = () => {
        // 判断是否加入设置页面
        let { isShowSettingPage } = this.state;
        if (isShowSettingPage) {
            this.setState({
                isShowSettingPage: false,
            })
        } else {
            utils.routeJump(this, "/speedOpt")
        }
    }

    //点击联系客服
    handleContactService = async () => {
        try {
            window.Willdesk.show()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 关闭
    closeImageShow = () => {
        this.setState({
            imgUrl: ''
        })
    }

    // 升级套餐
    upgradeShow = () => {
        let { excessPlan } = this.state;
        this.props.show(excessPlan === 2 ? 1 : 2);
        this.setState({
            isShowConfirmModal: false,
            modalToPlan: true,
        })
    }

    // 关闭恢复列表弹窗
    closeRestoreListModal = () => {
        this.setState({
            isShowRestoreListModal: false,
            selectThemeId: -1,
        }, () => {
            this.clearErrorBanner();
        })
    }

    // 重新发起优化
    restartOptFunc = (e) => {
        e.stopPropagation();
        let { isTimeOut } = this.state;
        if (isTimeOut) {
            this.setState({
                reoptLoading: true
            }, async () => {
                const res = await reqRestartSpeedUp();
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg);
                    this.setState({
                        isTimeOut: false,
                        reoptLoading: false
                    }, () => {
                        this.getSpeedupRecord();
                    })
                } else {
                    this.setState({
                        reoptLoading: false,
                        bannerSite: 'top',
                    }, () => {
                        this.setErrorBanner(res.msg);
                    })
                }
            })
        }
    }

    componentWillUnmount() {
        this.clearThemeGet();
        this.clearRecordGet();
    }

    render() {
        const {
            loadingPage,
            planId,
            isShowProgress,
            isShowConfirmModal,
            isShowPublicTip,
            questionList,
            serversList,
            isShowSettingPage,
            level,
            taskCpl,
            taskAll,
            isShowCompleteBanner,
            isShowChooseTheme,
            isShowSuccessBanner,
            tabKey,
            upgradeBtn,
            speedupCopyState,
            speedupCopyLoading,
            speedupThemeName,
            themeList,
            themeListLoading,
            selectThemeId,
            isSwitch,
            imgUrl,
            btnCopySupLoading,
            recordList,
            LastOptTime,
            isAllBtnFalse,
            publicBtnLoading,
            isShowErrorTip,
            isSetState,
            bannerSite,
            operaThemeId,
            operaThemeName,
            domain,
            excessPlan,
            isOnlySpeedLoading,
            // isShowSpedTip,
            isShowRestoreListModal,
            restoreThemeList,
            themeAppExtensionUrl,
            restoreListLoading,
            startRestoreLoading,
            currentThemeId,
            isTimeOut,
            reoptLoading,
            isPwd,

            isShowSecTip,
            isShowPop,
            isGuideTip,
            reduxLoading,
            isForbitSpeedup,

        } = this.state;

        // 判断是否shopify内嵌模式
        const shopifyMode = store.getState().public.isShowTopMenu || 1;

        // 错误banner
        const errorBannerBox = isShowErrorTip && <div>
            <Banner
                title={t(isShowErrorTip)}
                tone={isSetState ? "critical" : "warning"}
                onDismiss={this.clearErrorBanner}
                action={{
                    content: t("contact us"),
                    onAction: this.handleContactService
                }}
            >
            </Banner>
        </div>

        // 付费版本比较弹窗
        const comparePlanModal = <UpgradeModal
            isCustomize={true}
            cusTitle={t("Compare plans")}
            cusServerList={serversList}
            upgradeModalShow={upgradeBtn}
            changeUpgradeState={this.changeUpgradeState}
            toggleToast={this.props.toggleToast}
        />

        // 加速确认弹窗
        const lock = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.75 13.0493C11.1984 12.79 11.5 12.3052 11.5 11.75C11.5 10.9216 10.8284 10.25 10 10.25C9.17157 10.25 8.5 10.9216 8.5 11.75C8.5 12.3052 8.80165 12.79 9.25 13.0493V13.5C9.25 13.9142 9.58579 14.25 10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V13.0493Z" fill="#8A8A8A" />
            <path fillRule="evenodd" clipRule="evenodd" d="M6.25 7.09451V6.75C6.25 4.67893 7.92893 3 10 3C12.0711 3 13.75 4.67893 13.75 6.75V7.09451C15.0439 7.42755 16 8.60212 16 10V14C16 15.6569 14.6569 17 13 17H7C5.34315 17 4 15.6569 4 14V10C4 8.60212 4.95608 7.42755 6.25 7.09451ZM7.75 6.75C7.75 5.50736 8.75736 4.5 10 4.5C11.2426 4.5 12.25 5.50736 12.25 6.75V7H7.75V6.75ZM5.5 10C5.5 9.17157 6.17157 8.5 7 8.5H13C13.8284 8.5 14.5 9.17157 14.5 10V14C14.5 14.8284 13.8284 15.5 13 15.5H7C6.17157 15.5 5.5 14.8284 5.5 14V10Z" fill="#8A8A8A" />
        </svg>
        const speedupConfirmModal = <Modal
            open={isShowConfirmModal}
            title={t("Speed up confirmation")}
            primaryAction={
                (excessPlan > level) ? {
                    content: t("Upgrade plan"),
                    onAction: this.upgradeShow,
                    disabled: isOnlySpeedLoading,
                } : isForbitSpeedup ? null : {
                    content: t("Speed up now"),
                    onAction: this.speedUpNow,
                    loading: isOnlySpeedLoading,
                }
            }
            secondaryActions={isForbitSpeedup ? null : [
                {
                    content: t("Cancel"),
                    disabled: isOnlySpeedLoading,
                    onAction: () => this.toggleComfirmModal(false),
                }
            ]}
            onClose={() => this.toggleComfirmModal(false)}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    {bannerSite === 'modal' && errorBannerBox}
                    <p>{t("Please select the acceleration function you want to apply to your website")}</p>
                    <div className="sucm_main">
                        {
                            serversList.map((item, index) => {
                                return <div key={item.id} className="sucm_items" style={(index === serversList.length - 1) ? { borderBottom: 'unset' } : {}}>
                                    <div className="sucm_items_main">
                                        <div className="sucm_title">
                                            <p className="sucm_title_answer">
                                                {t(item.name)}
                                                <Tooltip content={t(item.desc)}>
                                                    <Icon tone="base" source={QuestionMarkMinor} />
                                                </Tooltip>
                                            </p>
                                            {
                                                (item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : <div className="sucm_lock">{lock} <span>{item.plan === 2 ? t("Pro plan") : t("Pre plan")}</span></div>
                                            }
                                        </div>
                                        <div className="custome_switch flex_layout">
                                            {/* {isSwitch === item.id && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />} */}
                                            <Switch disabled={level === 3 && item.title === "optimize_loading" && isPwd} onChange={() => this.handleChangeModalSwitch(item, true, false)} checked={Boolean(item.mStatus)} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                        </div>
                                    </div>
                                    {
                                        level === 3 && item.title === "optimize_loading" && isPwd ? <div className="pwd_tip flex_layout">
                                            <Icon source={CircleAlertMajor} tone="base" />
                                            <span>{t("Your website is currently password-protected and this feature cannot be used.")}</span>
                                        </div> : null
                                    }
                                </div>
                            })
                        }

                    </div>
                    {
                        isForbitSpeedup ? <div className="forbit_footer flex_layout">
                            <Button onClick={() => this.toggleComfirmModal(false)}>{t("Cancel")}</Button>
                            <Tooltip content={t("Wait {{v1}} minutes between accelerations.", 30)}>
                                <Button disabled={true}>{t("Speed up now")}</Button>
                            </Tooltip>
                        </div> : null
                    }
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 加速完成提示banner
        const completeBanner = isShowCompleteBanner && <Banner
            title={t("Speed Optimization Completed!")}
            tone="success"
            // action={{
            //     outline: true,
            //     content: t("Preview"),
            //     onAction: () => {
            //         window.open(`https://${domain}/?_ab=0&_fd=0&_sc=1&preview_theme_id=${operaThemeId}`)
            //     }
            // }}
            // secondaryAction={{
            //     content: t("Publish"),
            //     onAction: this.togglePublicTipState
            // }}
            onDismiss={() => this.setCompleteBanner(false)}
        >
            <BlockStack gap={200}>
                <div>
                    <p>{t("We have successfully optimized the speed of your website's")} <span style={{ fontWeight: "700", color: "#000" }}>【{operaThemeName}】</span> {t("theme")}.</p>
                    <p>{t("Please publish the theme after confirming that there are no issues in the preview.")}</p>
                </div>
                <div className="flex_layout">
                    <Button onClick={this.togglePublicTipState}>{t("Publish")}</Button>
                    <Button variant="plain" icon={ViewMinor} onClick={() => {
                        window.open(`https://${domain}/?_ab=0&_fd=0&_sc=1&preview_theme_id=${operaThemeId}`)
                    }}>{t("Preview")}</Button>
                </div>
            </BlockStack>
        </Banner>

        // 发布成功提示
        const successPublicBanner = isShowSuccessBanner && <Banner
            title={t("Theme published!")}
            tone="success"
            action={{
                content: t("Preview"),
                onAction: () => {
                    window.open(`https://${domain}/?_ab=0&_fd=0&_sc=1&preview_theme_id=${operaThemeId}`)
                }
            }}
            secondaryAction={{
                content: t("Restore"),
                variant: 'plain',
                loading: publicBtnLoading,
                onAction: () => this.publishThemeData(2),
            }}
            onDismiss={() => this.setSuccessBanner(false)}
        >
            <p>{t("If you encounter any issues, please contact our support team or restore to original theme.")}</p>
        </Banner>

        // 恢复主题列表弹窗
        const restoreListModal = <Modal
            open={isShowRestoreListModal}
            title={t("Choose which theme to restore to")}
            primaryAction={[
                {
                    content: t("Yes"),
                    loading: startRestoreLoading,
                    disabled: selectThemeId === -1,
                    onAction: this.startRestoreTheme
                }
            ]}
            secondaryActions={[
                {
                    content: t("Cancel"),
                    disabled: startRestoreLoading,
                    onAction: this.closeRestoreListModal,
                },
            ]}
            onClose={this.closeRestoreListModal}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    {bannerSite === 'modal' && errorBannerBox}
                    <div className="re_theme_list">
                        {
                            restoreListLoading ? <Spinner size="small" /> :
                                restoreThemeList.map((item, index) => {
                                    return ((Number(item.theme_id) === Number(currentThemeId)) || item.is_published === 0) ? null : <div className="re_theme_items" key={item.theme_id} onClick={() => this.handleSelectTheme(item.theme_id, Number(item.theme_id) === Number(currentThemeId))}>
                                        <RadioButton
                                            label={
                                                <p className="re_theme_info">
                                                    <span>{item.name}</span>
                                                    {
                                                        index === 0 ? <span className="re_theme_active">{t("Original theme")}</span> :
                                                            Number(item.theme_id) === Number(currentThemeId) ? <span className="re_theme_del">{t("Current theme")}</span> : null
                                                    }
                                                </p>
                                            }
                                            helpText={<Text as="p" tone="subdued">{t("Added")}: {formatTimestamp(item.created_at * 1000)}</Text>}
                                            checked={item.theme_id === selectThemeId}
                                            disabled={Number(item.theme_id) === Number(currentThemeId)}
                                            id={`${item.name}-${item.theme_id}`}
                                            onChange={() => this.handleSelectTheme(item.theme_id, item.is_del)}
                                        />
                                    </div>
                                })
                        }
                    </div>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 发布主题提示弹窗
        const publicThemeModal = <Modal
            open={isShowPublicTip}
            title={t("Publish theme")}
            primaryAction={[
                {
                    content: t("Publish theme"),
                    onAction: () => this.publishThemeData(1),
                    loading: publicBtnLoading,
                }
            ]}
            secondaryActions={[
                {
                    content: t("Cancel"),
                    onAction: this.togglePublicTipState,
                    disabled: publicBtnLoading,
                },
            ]}
            onClose={this.togglePublicTipState}
        >
            <Modal.Section>
                <BlockStack gap={300}>
                    {bannerSite === 'modal' && errorBannerBox}
                    <Text variant="headingMd" as="h2">{t("Before publishing the theme, we recommend checking the following to ensure everything on your website is functioning correctly")}: </Text>
                    <BlockStack gap={150}>
                        <Text as="p" tone="subdued">1.{t("Verify that the layout, fonts, colors, and images on your website remain consistent after optimization, and ensure that no styles are missing or misaligned.")}</Text>
                        <Text as="p" tone="subdued">2.{t("Test the navigation menu to confirm it is working properly, including the functionality of dropdown menus and links.")}</Text>
                        <Text as="p" tone="subdued">3.{t("Ensure all forms, buttons, and interactive elements (such as sliders and pop-ups) are functioning as expected.")}</Text>
                        <Text as="p" tone="subdued">4.{t("Check that images and videos on your website load correctly.")}</Text>
                        <Text as="p" tone="subdued">5.{t("Experience the entire website from a user's perspective, testing key functions such as login, registration, and checkout, to ensure these essential features are not affected.")}</Text>
                    </BlockStack>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 选择加速主题
        const chooseThemeModal = <Modal
            open={isShowChooseTheme}
            title={t("Choose a theme to speed up")}
            primaryAction={[
                tabKey === 0 ? {
                    content: t("Speed up copied themes"),
                    disabled: speedupCopyState,
                    loading: btnCopySupLoading,
                    onAction: () => this.SpeedupCopyTheme('copy'),
                } : {
                    content: t("Speed up now"),
                    disabled: themeListLoading || btnCopySupLoading || selectThemeId === -1,
                    loading: btnCopySupLoading,
                    onAction: () => this.SpeedupCopyTheme('opt')
                }
            ]}
            secondaryActions={
                [
                    {
                        content: t("Back"),
                        onAction: this.goBackServerList,
                        disabled: btnCopySupLoading,
                    },
                ]}
            onClose={this.goBackServerList}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    <Tabs tabs={[
                        {
                            id: 'CopyTheme',
                            content: t("Copy theme"),
                        },
                        {
                            id: 'SEOAntSped-UpThemes',
                            content: t("Themes Copied via SEOAnt"),
                        }
                    ]} selected={tabKey} onSelect={this.handleSelectTabs}>
                        {bannerSite === 'modal' && errorBannerBox}
                        <div className="theme_opera">
                            {
                                tabKey === 0 ? <BlockStack gap={200}>
                                    <Text as="p" tone="subdued">{t("Create a copy of your theme. Test speed optimizations in the copied theme to prevent any impact on the original")}</Text>
                                    <div className="theme_copy_process">
                                        <div className="text_process">
                                            <Icon source={CircleAlertMajor} />
                                            <div>
                                                <p>{`${t("Go to themes")} → ${t("Select your theme")} → ${t("Click Duplicate. Duplicate theme will be auto-synced here.")}`}</p>
                                                {
                                                    speedupThemeName ? <Button disabled={true}>
                                                        {t("Duplicated theme")}: 【{speedupThemeName}】
                                                    </Button> : <Button loading={speedupCopyLoading} onClick={this.GotoTheme}>{t("To copy theme")}</Button>
                                                }
                                            </div>
                                        </div>
                                        <div className="img_process" onClick={() => this.openViewImage("/website/theme_tip.png")}>
                                            <img src="/website/theme_tip.png" alt="" />
                                        </div>
                                    </div>
                                </BlockStack> : <div className="theme_speedup_list">
                                    {/* {
                                        isShowSpedTip && <Banner
                                            title={t("Currently deleted themes cannot be sped-up again~")}
                                            onDismiss={() => {
                                                this.setState({ isShowSpedTip: false })
                                            }}
                                        ></Banner>
                                    } */}
                                    {
                                        themeListLoading ? <div className="theme_list_spinner"><Spinner size="small" /></div> : (themeList.length > 0 ? <div className="theme_all_list">
                                            {
                                                themeList.map(item => {
                                                    return <div className="theme_items" key={item.theme_id} onClick={() => this.handleSelectTheme(item.theme_id, item.is_del)}>
                                                        <RadioButton
                                                            label={
                                                                <p className="theme_info">
                                                                    <span>{item.name}</span>
                                                                    {
                                                                        item.role === "main" ? <span className="theme_active">{t("Current theme")}</span> :
                                                                            item.is_del ? <span className="theme_del">{t("Deleted theme")}</span> : null
                                                                    }
                                                                </p>
                                                            }
                                                            helpText={<Text as="p" tone="subdued">{t("Added")}: {formatTimestamp(item.created_at * 1000)}</Text>}
                                                            checked={item.theme_id === selectThemeId}
                                                            disabled={item.is_del}
                                                            id={`${item.name}-${item.theme_id}`}
                                                            onChange={() => this.handleSelectTheme(item.theme_id, item.is_del)}
                                                        />
                                                    </div>
                                                })
                                            }
                                        </div> : <div className="theme_empty_list">
                                            <Text as="h2" variant="headingMd">{t("No Themes Copied via SEOAnt")}</Text>
                                            <Text as="p" tone="subdued">{t("You have not copied any themes via SEOAnt yet. You can click on the left to copy the theme as your own and speed up with one click!")}</Text>
                                        </div>)
                                    }
                                </div>
                            }
                        </div>
                    </Tabs>
                </BlockStack>
            </Modal.Section>
        </Modal >

        // 常见问题
        const FrequentAsk = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 主内容
        const pageMain = loadingPage ? <SkeltonLoading /> : <Page
            title={shopifyMode ? (isShowSettingPage ? t("Speed Up Settings") : "") : ""}
            // subtitle={isShowSettingPage ? null : t("Site speed is an important ranking factor. It calculates the time it takes for a user to click on a link on a search engine results page to load.")}
            backAction={isShowSettingPage ? {
                content: t("Site Speed Up"),
                onAction: this.goBack,
            } : null}
        >
            {
                !isShowSettingPage ?
                    <BlockStack gap={400}>
                        {bannerSite === 'top' && errorBannerBox}
                        {completeBanner}
                        {successPublicBanner}
                        <div className="sm_top_action">
                            <Card>
                                <div className="flex_layout speedup_top">
                                    <Text variant="headingMd" as="h2">{t("Speed up plan")}</Text>
                                    <Button variant="plain" onClick={this.toggleCompareModal}>{t("Compare plans")}</Button>
                                </div>
                                <div className="speedup_main">
                                    <div className="sm_select sm_items">
                                        <BlockStack gap={400}>
                                            <div className="sm_img">
                                                <div onClick={() => this.changePlanId(1)}><Icon source={SpeedBasicIcon} /></div>
                                                <div onClick={() => this.changePlanId(2)}><Icon source={SpeedFastIcon} /></div>
                                                <div onClick={() => this.changePlanId(3)}><Icon source={SpeedRocketIcon} /></div>
                                            </div>
                                            <BlockStack gap={100}>
                                                <div className="sm_progress">
                                                    <div className="p_line"></div>
                                                    <div onClick={(e) => this.changePlanId(1, e)} className="p_line_transparent"></div>
                                                    <div className="p_line_active" style={{
                                                        width: `calc(${(planId - 1) * 50}% - ${(planId - 1) * 15}px)`
                                                    }}></div>
                                                    <p onClick={() => this.changePlanId(1)} className={`p_points ${planId >= 1 ? "p_active" : ""}`}></p>
                                                    <p onClick={() => this.changePlanId(2)} className={`p_points ${planId >= 2 ? "p_active" : ""}`}></p>
                                                    <p onClick={() => this.changePlanId(3)} className={`p_points ${planId === 3 ? "p_active" : ""}`}></p>
                                                </div>
                                                <div className="sm_text">
                                                    <div className="t_name" onClick={() => this.changePlanId(1)}>
                                                        <p className={`${planId === 1 ? 't_active' : ''}`}>{t("Basic")}</p>
                                                        {level === 1 && <span>({t("Current")})</span>}
                                                    </div>
                                                    <div className="t_name">
                                                        <p onClick={() => this.changePlanId(2)} className={`${planId === 2 ? 't_active' : ''}`}>{t("Pro")}</p>
                                                        {level === 2 && <span>({t("Current")})</span>}
                                                    </div>
                                                    <div className="t_name" >
                                                        <p onClick={() => this.changePlanId(3)} className={`${planId === 3 ? 't_active' : ''}`}>{t("Pre")}</p>
                                                        {level === 3 && <span>({t("Current")})</span>}
                                                    </div>
                                                </div>
                                            </BlockStack>
                                        </BlockStack>
                                    </div>
                                    <div className="sm_setting sm_items">
                                        <Card>
                                            <BlockStack gap={200}>
                                                <div className="flex_layout">
                                                    <Text variant="headingMd" as="h3">{t("Speed up effect")}: </Text>
                                                    <Badge tone="success">{planId === 1 ? t("Basic") : planId === 2 ? t("Fast") : t("Rocket")}</Badge>
                                                </div>
                                                <div className="sm_wedo">
                                                    <Text variant="headingMd" as="h3">{t("What we do")}:&nbsp;&nbsp;</Text>
                                                    {
                                                        planId === 1 ? <p className="sm_do_items"><span>{t("Instant Page")}</span></p> : planId === 2 ? <p className="sm_do_items">
                                                            <span>{t("Instant Page")}</span>、
                                                            <span>{t("Streamlined Loading")}</span>、
                                                            <span>{t("Lazy Load Images")}</span>
                                                        </p> : <div className="sm_do_items">
                                                            <p>{t("All features")}:&nbsp;&nbsp;</p>
                                                            <span>{t("Instant Page")}</span>、
                                                            <span>{t("Streamlined Loading")}</span>、
                                                            <span>{t("Lazy Load Images")}</span>、
                                                            <span>{t("Lazy Load Videos & Iframes")}</span>、
                                                            <span>{t("Optimized Loading")}</span>、
                                                            <span>{t("Asset File Optimization")}</span>、
                                                            <span>{t("Streamline Code")}</span>
                                                        </div>
                                                    }&nbsp;&nbsp;
                                                    <Button disabled={isAllBtnFalse} variant="plain" onClick={this.openSettingPage}>{t("View details")}</Button>
                                                </div>
                                                <div className="sm_action flex_layout">
                                                    <Button variant="primary" disabled={isAllBtnFalse} loading={isAllBtnFalse || reduxLoading} icon={LightningIcon} onClick={() => this.toggleComfirmModal(true)}>{t("One-click speed up")}</Button>
                                                    <Button icon={SettingsIcon} disabled={isAllBtnFalse || reduxLoading} onClick={this.openSettingPage}>{t("Settings")}</Button>
                                                    {
                                                        (isShowSecTip && isGuideTip) && <div className={`sec_tip popover_tip ${isShowPop ? "showPop" : ""}`}>
                                                            <div className="pop_main">
                                                                <div className="pop_child">
                                                                    <p>{t("Click to speed up your store")}</p>
                                                                    <div><Button variant="primary" onClick={() => this.toggleComfirmModal(true)}>{t("Got it")}</Button></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <Text as="p" tone="subdued">{t("Last optimization time")}:&nbsp;&nbsp;{LastOptTime ? formatTimestamp(LastOptTime * 1000, true) : '--'}</Text>
                                            </BlockStack>
                                        </Card>
                                    </div>
                                </div>
                            </Card>
                        </div>

                        <Card padding={200}>
                            <div onClick={this.toggleProgressList} className="speedup_col">
                                <BlockStack gap={200}>
                                    <div className="flex_layout speedup_progress_list">
                                        <Text variant="headingMd" as="h2">{t("Speed up progress")}</Text>
                                        <div className="flex_layout" style={{ columnGap: '1em' }}>
                                            {
                                                isTimeOut && <Text as="p" tone="subdued">{t("No response?")}&nbsp;&nbsp;<Button variant="plain" onClick={(e) => this.restartOptFunc(e)} loading={reoptLoading}>{t("Re-optimize")}</Button></Text>
                                            }
                                            <span><Icon source={!isShowProgress ? ChevronDownMinor : ChevronUpMinor} /></span>
                                        </div>
                                    </div>
                                    <div className="flex_layout speedup_task">
                                        {
                                            taskAll === 0 ? <ProgressBar size="small" tone="primary" progress={0} /> : <ProgressBar size="small" tone="primary" progress={100 * (taskCpl / taskAll)} />
                                        }
                                        <span>{taskCpl}/{taskAll} {t("tasks")}</span>
                                    </div>
                                </BlockStack>
                            </div>
                            <Collapsible
                                open={isShowProgress}
                                id={`SiteSpeedup-collapsible`}
                                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                            >
                                <div className="progress_list">
                                    {
                                        recordList.filter(i => i.SupStatus !== 0).length > 0 ?
                                            recordList.map((item) => {
                                                return (item.SupStatus > 0) && <div className="do_items" key={`${item.id}-${item.title}`}>
                                                    <div className="do_status">
                                                        {
                                                            item.SupStatus === 3 ? <Icon source={MobileHorizontalDotsMajor} tone="base" /> :
                                                                item.SupStatus === 2 ? <Spinner size="small" /> :
                                                                    item.SupStatus === 1 ? <span>
                                                                        <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M15.7803 5.96967C16.0732 6.26256 16.0732 6.73744 15.7803 7.03033L9.28033 13.5303C8.98744 13.8232 8.51256 13.8232 8.21967 13.5303L4.96967 10.2803C4.67678 9.98744 4.67678 9.51256 4.96967 9.21967C5.26256 8.92678 5.73744 8.92678 6.03033 9.21967L8.75 11.9393L14.7197 5.96967C15.0126 5.67678 15.4874 5.67678 15.7803 5.96967Z" fill="#29845A" />
                                                                        </svg>
                                                                    </span> : null
                                                        }
                                                    </div>
                                                    <p className="do_main">
                                                        {t(item.do)}&nbsp;
                                                        {
                                                            item.title === "read_all_files" && <span>
                                                                {
                                                                    item.SupStatus === 3 ? "..." : item.SupStatus === 2 ? `(${item.nums.current}/${item.nums.all})` : ""
                                                                }
                                                            </span>
                                                        }
                                                    </p>
                                                    <span className={`do_badge ${item.SupStatus === 2 ? "do_going" : item.SupStatus === 1 ? "do_finish" : "do_not"}`}>
                                                        {item.SupStatus === 2 ? t("Ongoing") : item.SupStatus === 1 ? t("Completed") : t("Not started")}
                                                    </span>
                                                </div>
                                            }) : <span style={{ padding: '5px 10px' }}>{t("No program in progress")}</span>
                                    }
                                </div>
                            </Collapsible>
                        </Card>

                        {FrequentAsk}
                    </BlockStack> : <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={200}>
                                <Text variant="headingMd" as="h2">{t("Global Features")}</Text>
                                <Text as="p" tone="subdued">
                                    {t("The following features will be applied directly to your website without affecting the theme code. Changes will take effect immediately upon clicking to enable or disable.")}&nbsp;
                                    {t("Before using this function, please enable the")}&nbsp;
                                    <Button variant="plain" onClick={() => {
                                        window.open(themeAppExtensionUrl)
                                    }}>{t("APP embed block")}</Button>.
                                </Text>
                                <div className="setting_main">
                                    {
                                        serversList.map((item, index) => {
                                            return index < 2 ? <div className="setting_list" key={item.id} style={(index === 1) ? { borderBottom: 'unset' } : {}}>
                                                <div className="setting_img">
                                                    <Icon source={item.svg} />
                                                </div>
                                                <div className="setting_item">
                                                    <div className="si_info">
                                                        <div className="setting_title">
                                                            <p className="setting_title_answer">
                                                                {t(item.name)}
                                                            </p>
                                                            {
                                                                (item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : <div className="setting_lock">{lock} <span>{item.plan === 2 ? t("Pro plan") : t("Pre plan")}</span></div>
                                                            }
                                                        </div>
                                                        <p>
                                                            {t(item.desc)}&nbsp;
                                                        </p>
                                                    </div>
                                                    <div className="si_switch flex_layout" style={{ display: item.copys ? 'none' : '' }}>
                                                        {isSwitch === item.id && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                                        <Switch disabled={isSwitch !== -1} onChange={() => this.handleChangeSwitch(item)} checked={Boolean(item.status)} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                                    </div>
                                                </div>
                                            </div> : null
                                        })
                                    }
                                </div>
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={200}>
                                <Text variant="headingMd" as="h2">{t("Optimize Theme Features")}</Text>
                                <div className="setting_main">
                                    {
                                        serversList.map((item, index) => {
                                            return index >= 2 ? <div className="setting_list" key={item.id} style={(index === serversList.length - 1) ? { borderBottom: 'unset' } : {}}>
                                                <div className="setting_img">
                                                    <Icon source={item.svg} />
                                                </div>
                                                <div className="setting_item">
                                                    <div className="si_info">
                                                        <div className="setting_title">
                                                            <p className="setting_title_answer">
                                                                {t(item.name)}
                                                            </p>
                                                            {
                                                                (item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : <div className="setting_lock">{lock} <span>{item.plan === 2 ? t("Pro plan") : t("Pre plan")}</span></div>
                                                            }
                                                        </div>
                                                        <p>
                                                            {t(item.desc)}&nbsp;
                                                        </p>
                                                        {
                                                            level === 3 && item.title === "optimize_loading" && isPwd ? <div className="pwd_tip flex_layout" style={{ padding: '0.5rem 0 0' }}>
                                                                <Icon source={CircleAlertMajor} tone="base" />
                                                                <span>{t("Your website is currently password-protected and this feature cannot be used.")}</span>
                                                            </div> : null
                                                        }
                                                    </div>
                                                    <div className="si_switch flex_layout" style={{ display: item.copys ? 'none' : '' }}>
                                                        {isSwitch === item.id && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                                        <Switch disabled={isSwitch !== -1} onChange={() => this.handleChangeSwitch(item)} checked={Boolean(item.status)} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                                    </div>
                                                </div>
                                            </div> : null
                                        })
                                    }
                                </div>
                            </BlockStack>
                        </Card>
                    </BlockStack>
            }

            {FooterHelpBox}
        </Page>

        // 最终页面
        const pageContent = <div id="SiteSpeedup">
            <title>SEOAnt - Site Speed Up</title>

            {pageMain}
            {restoreListModal}
            {comparePlanModal}
            {speedupConfirmModal}
            {publicThemeModal}
            {chooseThemeModal}
            {
                Boolean(imgUrl) && <ViewImage imgUrl={imgUrl} closeImageShow={this.closeImageShow} />
            }
        </div>;

        return pageContent;
    }
}

// 时间格式
function formatTimestamp(timestamp, isYear = false) {
    const now = new Date();
    const date = new Date(timestamp);
    const timeDiff = (now - date) / 1000; // 计算时间差（秒）
    const minutesDiff = Math.floor(timeDiff / 60);
    const hoursDiff = Math.floor(timeDiff / 3600);
    // 如果时间差小于1小时，返回"xx minutes ago"
    if (hoursDiff < 1) {
        return minutesDiff <= 0 ? 'just now' : `${minutesDiff} minutes ago`;
    }
    // 如果时间大于1小时，返回日期和时间
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12; // 转换为12小时制
    let timeText = isYear ? `${t(month)} ${day}, ${year} ${hours}:${minutes} ${ampm}` : `${t(month)} ${day} at ${hours}:${minutes} ${ampm}`;
    return timeText;
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['SiteSpeedUp', data]));
    },
})


SiteSpeedup = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SiteSpeedup);

export default withRouter(SiteSpeedup);
